import { get, post } from './request'
import axios from 'axios'

export function getRichText(id) {
  return get(`/richtext/${id}`)
}

/**
 * 获取活动详情（外部 API 接口，供 H5 web-view 页面调用）
 * 自动处理 { code, data, msg } 等常见响应包装
 * @param {number|string} id 活动 ID
 * @returns {Promise<Object>} 活动详情数据对象
 */
export function getEventDetail(id) {
  return axios.get(`https://apitest.dronex.cc/api/events/item/detail/${id}`, { timeout: 15000 })
    .then(res => {
      const body = res.data
      // 处理 { code, data, msg } 包装
      if (body && body.code !== undefined) {
        return body.data || body
      }
      return body
    })
}

export default {
  getRichText,
  getEventDetail
}
